/* tslint:disable */
/* eslint-disable */
/**
 * SBL API Glommen Mjøsen Skog
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { GmDtoLibraryDtoTrackDamageTrackDamageOverviewListDto } from '../model';
// @ts-ignore
import { GmModelLibraryModelsTrackDamageOverviewQuery } from '../model';
// @ts-ignore
import { GmModelLibraryModelsTrackDamageTrackDamageUpdateInputDto } from '../model';
/**
 * TrackDamageApi - axios parameter creator
 * @export
 */
export const TrackDamageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get list of track damage that need followup  - action \"ctg_trackdamageoverview\"
         * @param {GmModelLibraryModelsTrackDamageOverviewQuery} [gmModelLibraryModelsTrackDamageOverviewQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackDamageGetTrackDamageOverview: async (gmModelLibraryModelsTrackDamageOverviewQuery?: GmModelLibraryModelsTrackDamageOverviewQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/trackDamage/get-track-damage-overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gmModelLibraryModelsTrackDamageOverviewQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update track damagage
         * @param {string} contractId 
         * @param {GmModelLibraryModelsTrackDamageTrackDamageUpdateInputDto} [gmModelLibraryModelsTrackDamageTrackDamageUpdateInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackDamageUpdateTrackDamage: async (contractId: string, gmModelLibraryModelsTrackDamageTrackDamageUpdateInputDto?: GmModelLibraryModelsTrackDamageTrackDamageUpdateInputDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('trackDamageUpdateTrackDamage', 'contractId', contractId)
            const localVarPath = `/v1/trackDamage/update-track-damage/{contractId}`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gmModelLibraryModelsTrackDamageTrackDamageUpdateInputDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrackDamageApi - functional programming interface
 * @export
 */
export const TrackDamageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TrackDamageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get list of track damage that need followup  - action \"ctg_trackdamageoverview\"
         * @param {GmModelLibraryModelsTrackDamageOverviewQuery} [gmModelLibraryModelsTrackDamageOverviewQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trackDamageGetTrackDamageOverview(gmModelLibraryModelsTrackDamageOverviewQuery?: GmModelLibraryModelsTrackDamageOverviewQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GmDtoLibraryDtoTrackDamageTrackDamageOverviewListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trackDamageGetTrackDamageOverview(gmModelLibraryModelsTrackDamageOverviewQuery, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TrackDamageApi.trackDamageGetTrackDamageOverview']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Update track damagage
         * @param {string} contractId 
         * @param {GmModelLibraryModelsTrackDamageTrackDamageUpdateInputDto} [gmModelLibraryModelsTrackDamageTrackDamageUpdateInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trackDamageUpdateTrackDamage(contractId: string, gmModelLibraryModelsTrackDamageTrackDamageUpdateInputDto?: GmModelLibraryModelsTrackDamageTrackDamageUpdateInputDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GmModelLibraryModelsTrackDamageTrackDamageUpdateInputDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trackDamageUpdateTrackDamage(contractId, gmModelLibraryModelsTrackDamageTrackDamageUpdateInputDto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TrackDamageApi.trackDamageUpdateTrackDamage']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * TrackDamageApi - factory interface
 * @export
 */
export const TrackDamageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TrackDamageApiFp(configuration)
    return {
        /**
         * 
         * @summary Get list of track damage that need followup  - action \"ctg_trackdamageoverview\"
         * @param {GmModelLibraryModelsTrackDamageOverviewQuery} [gmModelLibraryModelsTrackDamageOverviewQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackDamageGetTrackDamageOverview(gmModelLibraryModelsTrackDamageOverviewQuery?: GmModelLibraryModelsTrackDamageOverviewQuery, options?: any): AxiosPromise<GmDtoLibraryDtoTrackDamageTrackDamageOverviewListDto> {
            return localVarFp.trackDamageGetTrackDamageOverview(gmModelLibraryModelsTrackDamageOverviewQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update track damagage
         * @param {string} contractId 
         * @param {GmModelLibraryModelsTrackDamageTrackDamageUpdateInputDto} [gmModelLibraryModelsTrackDamageTrackDamageUpdateInputDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackDamageUpdateTrackDamage(contractId: string, gmModelLibraryModelsTrackDamageTrackDamageUpdateInputDto?: GmModelLibraryModelsTrackDamageTrackDamageUpdateInputDto, options?: any): AxiosPromise<GmModelLibraryModelsTrackDamageTrackDamageUpdateInputDto> {
            return localVarFp.trackDamageUpdateTrackDamage(contractId, gmModelLibraryModelsTrackDamageTrackDamageUpdateInputDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TrackDamageApi - object-oriented interface
 * @export
 * @class TrackDamageApi
 * @extends {BaseAPI}
 */
export class TrackDamageApi extends BaseAPI {
    /**
     * 
     * @summary Get list of track damage that need followup  - action \"ctg_trackdamageoverview\"
     * @param {GmModelLibraryModelsTrackDamageOverviewQuery} [gmModelLibraryModelsTrackDamageOverviewQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackDamageApi
     */
    public trackDamageGetTrackDamageOverview(gmModelLibraryModelsTrackDamageOverviewQuery?: GmModelLibraryModelsTrackDamageOverviewQuery, options?: RawAxiosRequestConfig) {
        return TrackDamageApiFp(this.configuration).trackDamageGetTrackDamageOverview(gmModelLibraryModelsTrackDamageOverviewQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update track damagage
     * @param {string} contractId 
     * @param {GmModelLibraryModelsTrackDamageTrackDamageUpdateInputDto} [gmModelLibraryModelsTrackDamageTrackDamageUpdateInputDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackDamageApi
     */
    public trackDamageUpdateTrackDamage(contractId: string, gmModelLibraryModelsTrackDamageTrackDamageUpdateInputDto?: GmModelLibraryModelsTrackDamageTrackDamageUpdateInputDto, options?: RawAxiosRequestConfig) {
        return TrackDamageApiFp(this.configuration).trackDamageUpdateTrackDamage(contractId, gmModelLibraryModelsTrackDamageTrackDamageUpdateInputDto, options).then((request) => request(this.axios, this.basePath));
    }
}

